module.exports = __webpack_public_path__ + "static/media/Avatars_Other_New-01.eb233705.jpg";